import * as THREE from 'three';

// Loads the storm tools/build-thunderhead.mjs prepared - the dark photo, the
// three light layers (R, G, B = left, centre, right), the lossless masks
// (R clear sky, G cloud, B foreground) and the flow field - once, at startup,
// for visualizers/thunderhead.js. Same preload/get shape as
// cloudsea-assets.js, and the same rule: the preload is a WIRING POINT every
// entry point must call (main, main-radio, main-embedded, play-boot,
// player-boot, landing-boot, demo-boot, the capture harness). Without the
// manifest, the dark photo, the lights or the masks it resolves to null and
// the entry points withdraw Thunderhead (disableVisualization).
const MANIFEST_URL = 'textures/thunderhead.json';

let _assets = null;
let _promise = null;

function loadTexture(url, data) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) {
      // the lights, the masks and the flow are data: no colour space; linear
      // filtering keeps the build's softened edges
      t.colorSpace = data ? THREE.NoColorSpace : THREE.SRGBColorSpace;
      t.generateMipmaps = false;
      t.minFilter = THREE.LinearFilter;
      t.magFilter = THREE.LinearFilter;
      t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
      t.needsUpdate = true;
      resolve(t);
    }, undefined, function () { reject(new Error(url + ' failed to load')); });
  });
}

export function preloadThunderhead() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('thunderhead.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (m) {
      if (!m.dark || !m.lights || !m.masks || !m.flow || !m.layers || !m.layers.length) throw new Error('thunderhead.json incomplete (run tools/build-thunderhead.mjs)');
      const T = (f, data) => loadTexture('textures/' + f, data);
      // the dark photo too is loaded RAW (no colour space): the visualizer
      // composites in the sRGB domain, where the light layers were measured,
      // and converts once at the end
      return Promise.all([T(m.dark, true), T(m.lights, true), T(m.masks, true), T(m.flow, true)]).then(function (t) {
        _assets = { manifest: m, dark: t[0], lights: t[1], masks: t[2], flow: t[3] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] thunderhead assets unavailable, Thunderhead will not be offered', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getThunderhead() {
  return _assets;
}
